// (C) Copyright 2020 MediaWink, LLC

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
} from '@material-ui/core';

import Spinner from './spinner/spinner';
import {
  triggerLogoutSaga,
} from '../actions/session';

function SignOut() {
  const navigate = useNavigate();
  const { promiseInProgress } = usePromiseTracker();
  const loginState = useSelector((state) => state.undo.present.private.login);
  const dispatch = useDispatch();
  const logout = (data, resolve, reject, nav) => dispatch(
    triggerLogoutSaga(data, resolve, reject, nav),
  );
  return (
    <>
      {promiseInProgress && <Spinner text='Signing out...' />}
      {loginState.isLoggedIn // TODO: Remove loginstate.isLoggedIn check
      && (
      <Box gap='small' align='center'>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            let p;
            console.log('new Promise: Sihn out');
            trackPromise(
              p = new Promise((resolve, reject) => {
                logout(loginState, resolve, reject, navigate);
              }),
            );
            p.catch(() => {
            });
          }}
        >
          <Button
            color='primary'
            type='submit'
            variant='contained'
          >
            Sign Out
          </Button>
        </form>
      </Box>
      )}
    </>
  );
}

export default SignOut;
